// extracted by mini-css-extract-plugin
module.exports = {"itemHeader":"serviceListItem_itemHeader__2WLB7","text":"serviceListItem_text__I2KQv","title":"serviceListItem_title__vQNaF","titleLong":"serviceListItem_titleLong__J5D9E"};